import { axiosInstance } from "@src/api/axiosConfig";
import { axiosPath } from "@src/api/axiosPath";

export const useUserSubsInfo = async () => {
    const response = await axiosInstance.get(`${axiosPath.userSubsInfo}`);
    return response;
};
